
import React from 'react';

export const MediaQueryContext = React.createContext(getMediaQuery());
export function getMediaQuery() {
  return{
    isMobile: window.matchMedia('(max-width: 600px)').matches,
    isTablet: window.matchMedia('(min-width: 601) and (max-width: 1200px)').matches,
    isDesktop: window.matchMedia('(min-width: 1201px)').matches
  }
}
